import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { PackageUsedBy } from '@openx/types/package/PackageHookTypes.ts';
import { type JSX, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type UsedByCellProps = {
  usedByLoading: boolean;
  usedBy: PackageUsedBy | undefined;
};

export const UsedByCell = ({ usedBy, usedByLoading }: UsedByCellProps): JSX.Element => {
  const { t } = useTranslation();

  const getLabel = useCallback(
    (isLoading: boolean, data: PackageUsedBy['deals_referenced'] | PackageUsedBy['floorrules_referenced']) => {
      if (isLoading || typeof data === 'undefined') {
        return '-';
      }
      return data > 0 ? t('Yes') : t('No');
    },
    [t]
  );

  return (
    <>
      <Typography variant="body2" color="textSecondary">
        {t('Deals')}:{' '}
        <Box component={'span'} sx={{ color: 'black' }}>
          {getLabel(usedByLoading, usedBy?.deals_referenced)}
        </Box>
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {t('Brand Floors')}:{' '}
        <Box component={'span'} sx={{ color: 'black' }}>
          {getLabel(usedByLoading, usedBy?.floorrules_referenced)}
        </Box>
      </Typography>
    </>
  );
};
